import { useQuery } from '@tanstack/react-query';

import { getTeamMemberDetailsByRevisionDate } from '../api/team.api';

interface UseTeamMemberByRevisionDateParams {
  params: {
    teamMemberId: number;
    revisionDate: string;
  };
  enabled?: boolean;
}

/**
 * Hook to fetch full team member state at a specific revision date.
 * Used in EditChange mode to load historical team member data.
 * Returns the complete TeamMember state (info + billing + capacity) at the given date.
 */
export const useTeamMemberByRevisionDate = ({
  params,
  enabled = true,
}: UseTeamMemberByRevisionDateParams) => {
  const { teamMemberId, revisionDate } = params;

  return useQuery({
    queryKey: ['team-member-by-revision-date', teamMemberId, revisionDate],
    queryFn: () => getTeamMemberDetailsByRevisionDate(teamMemberId, revisionDate),
    enabled,
    staleTime: Infinity, // Historical data never changes, cache forever
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes after unmount
  });
};
